module.exports = __webpack_public_path__ + "img/add-outline.f2ad835b.svg";